import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[750px] flex items-center justify-center overflow-hidden pt-20">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20art%20composition%20with%20soft%20mustard%20yellow%20warm%20terracotta%20and%20olive%20green%20overlapping%20shapes%2C%20modern%20minimalist%20gradient%20background%20with%20subtle%20texture%20like%20handmade%20paper%2C%20clean%20contemporary%20aesthetic%2C%20no%20text%20no%20people%2C%20warm%20natural%20tones%2C%20high%20resolution%20editorial%20backdrop&width=1920&height=1080&seq=hero-bg-jun27-v2&orientation=landscape"
          alt="ItaobuySpreadsheet background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 max-w-6xl mx-auto text-center">
        <p className="text-sm md:text-base text-background-50/80 font-medium tracking-widest uppercase mb-5 animate-fade-in">
          ItaobuySpreadsheet 2026
        </p>
        <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 leading-tight mb-6 animate-fade-in-up">
          Best ItaobuySpreadsheet 2026
          <br />
          <span className="text-secondary-300">The Smart Way to Buy From China</span>
        </h1>
        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed animate-fade-in-up animation-delay-200">
          Discover verified itaobuyspreadsheet lists, compare top China shopping agents, and find the cheapest and safest way to shop from Taobao, 1688, and Weidian.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up animation-delay-400">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold px-10 py-4 rounded-full text-base transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            itaobuy sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm text-background-50 font-semibold px-10 py-4 rounded-full text-base border border-background-50/30 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            buy it now
          </a>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8 animate-fade-in-up animation-delay-600">
          <div className="flex items-center gap-2">
            <div className="w-2.5 h-2.5 rounded-full bg-secondary-400"></div>
            <span className="text-sm text-background-50/70">Weekly Updates</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-2.5 h-2.5 rounded-full bg-secondary-400"></div>
            <span className="text-sm text-background-50/70">Verified Agents</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-2.5 h-2.5 rounded-full bg-secondary-400"></div>
            <span className="text-sm text-background-50/70">Curated Lists</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 pb-6 animate-fade-in animation-delay-800">
        <i className="ri-arrow-down-line text-background-50/50 text-2xl"></i>
      </div>
    </section>
  );
}